import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm, submit, Form } from "redux-form";
import {
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Button,
  TextField,
  withMobileDialog,
  withStyles
} from "@material-ui/core";
import * as AccountActions from "../store/AccountHierarchy";
import * as SnackbarActions from "../store/SnackbarStore";
import { AddHierarchy, DuplicateHierarchy } from "../services/hierarchyService";
import styles from "../wrappers/admin/Admin.Styles";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";

const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;
const maxLength256 = maxLength(256);

const validate = values => {
  const errors = {};
  const requiredFields = ["name"];
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = "Required";
    }
  });

  if (maxLength256(values["name"])) {
    errors["name"] = maxLength256(values["name"]);
  }

  return errors;
};

const renderTextField = ({
  input,
  label,
  meta: { touched, error },
  ...custom
}) => {
  return (
    <TextField
      id="hierarchyName"
      name="hierarchyName"
      label="Hierarchy Name"
      helperText={touched && error}
      error={touched && error !== undefined}
      {...input}
      {...custom}
      margin="normal"
    />
  );
};

export const HierarchyModalFormMode = Object.freeze({
  ADD: Symbol("ADD"),
  EDIT: Symbol("edit"),
  DUPLICATE: Symbol("duplicate")
});

class HierarchyForm extends Component {
  handleSubmit = async hierarchy => {
    const { sendError, mode, sourceHierarchy } = this.props;

    try {
      let result = undefined;

      if (mode === HierarchyModalFormMode.DUPLICATE) {
        //Call the duplicate API
        result = await DuplicateHierarchy(sourceHierarchy.id, hierarchy);
      } else {
        result = await AddHierarchy(hierarchy);
      }
      if (result) {
        this.props.submitted();
      }
    } catch (error) {
      sendError(error);
    }
  };

  render() {
    const { classes, handleSubmit } = this.props;

    return (
      <Form onSubmit={handleSubmit(this.handleSubmit)}>
        <Field
          name="name"
          component={renderTextField}
          label="Hierarchy Name"
          className={classes.textFieldMed}
        />
      </Form>
    );
  }
}

function mapStateToProps(state) {
  return {
    initialValues: state.hierarchyModal.data
  };
}

HierarchyForm = connect(
  mapStateToProps,
  dispatch =>
    bindActionCreators(
      Object.assign(
        {},
        SnackbarActions.actionCreators,
        AccountActions.actionCreators
      ),
      dispatch
    )
)(
  reduxForm({
    form: "HierarchyForm",
    validate
  })(withStyles(styles)(HierarchyForm))
);

class HierarchyModalForm extends Component {
  state = {
    hierarchy: {
      name: ""
    }
  };

  componentDidMount() {
    const { hierarchy } = this.props;
    this.setState({ hierarchy: { ...hierarchy } });
  }

  getTitle = () => {
    const { mode } = this.props;
    if (mode === HierarchyModalFormMode.DUPLICATE) {
      return "Duplicate Hierarchy";
    }

    return mode === HierarchyModalFormMode.EDIT
      ? "Edit Hierarchy"
      : "Add Hierarchy";
  };

  render() {
    const {
      open,
      fullscreen,
      handleClose,
      dispatch,
      mode,
      sourceHierarchy
    } = this.props;

    return (
      <Dialog
        fullscreen={fullscreen}
        open={open}
        onClose={this.handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {this.getTitle()}
        </DialogTitle>
        <DialogContent>
          <HierarchyForm
            submitted={handleClose}
            mode={mode}
            sourceHierarchy={sourceHierarchy}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              dispatch(submit("HierarchyForm"));
            }}
            color="primary"
          >
            Ok
          </Button>
          <Button onClick={handleClose} color="primary" autoFocus>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

HierarchyModalForm.propTypes = {
  open: PropTypes.bool.isRequired,
  mode: PropTypes.symbol.isRequired
};

export default connect(state => ({
  initialValues: state.hierarchyModal.data,
  mode: state.hierarchyModal.mode,
  sourceHierarchy: state.hierarchyModal.sourceHierarchy
}))(withStyles(styles)(withMobileDialog()(HierarchyModalForm)));
